








import { Component, Prop } from "vue-property-decorator";
import AppVue from "@/apps/AppVue.vue";

@Component({
    components: {
        //
    },
})
export default class DtEmpty extends AppVue {
    @Prop({ required: false, default: 'No data' }) description: string;

}
